import React              from 'react';
import useREST            from 'rest/useREST';
import { useNavigate }    from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSnackbar }    from 'notistack';
import useStyles          from './navBarStyles'

import AppBar        from '@mui/material/AppBar';
import Button        from '@mui/material/Button';
import ButtonNavLink from 'NavBar/ButtonNavLink';
import Grid          from '@mui/material/Grid';
import Tooltip       from '@mui/material/Tooltip';

import { AuthContext }              from 'App';
import { BACKEND_PATHS }            from 'rest/const';
import { HIDDEN_TABS }              from 'rest/const';
import internalPaths                from 'routing/internalPaths';


function NavBar() {

  const { classes }         = useStyles();
  const { t }               = useTranslation();
  const navigate            = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { setUserInfo }     = React.useContext(AuthContext);

  const [isLogoutInProgress, setIsLogoutInProgress] = React.useState(false);

  const leftAlignedButtons = [
    {
      path:        internalPaths.cardsInfo,
      buttonLabel: t('cardsInfoNavButton')
    },
    {
      path:        internalPaths.orderCards,
      buttonLabel: t('orderCardsNavButton')
    },
  ];

  if (!HIDDEN_TABS.reports) {
    leftAlignedButtons.push({
      path:        internalPaths.reports,
      buttonLabel: t('reportsNavButton'),
    });
  }

  if (!HIDDEN_TABS.massActivateCards) {
    leftAlignedButtons.push({
      path:        internalPaths.massActivateCards,
      buttonLabel: t('massActivateCardsNavButton'),
    });
  }

  const sendRequest = useREST();

  function onLogout() {
    setIsLogoutInProgress(true);
    sendRequest(BACKEND_PATHS.clearCookies, 'delete')
      .then(() => {
        setUserInfo(null);
        navigate(internalPaths.logout);
      })
      .catch(() => enqueueSnackbar(t('logoutFailed'), { variant: 'error' }))
      .then(() => setIsLogoutInProgress(false));
  }

  const logoutButtonTooltip = isLogoutInProgress ? t('logoutInProgress') : null;

  return (
    <AppBar
      position='static'
      elevation={2}
      className={classes.appBar}
    >
      <Grid container spacing={2} justifyContent='space-between' alignItems='center'>
        <Grid item>
          <Grid container spacing={2} alignItems='center'>
            {leftAlignedButtons.map((btn => (
              <Grid item key={btn.buttonLabel}>
                <ButtonNavLink disabled={isLogoutInProgress} to={btn.path}>
                  {btn.buttonLabel}
                </ButtonNavLink>
              </Grid>
            )))}
          </Grid>
        </Grid>
        <Grid item>
          <Tooltip title={logoutButtonTooltip} open={isLogoutInProgress}>
            <span> {/*//Disabled elements can't hold a ref required by Tooltip*/}
              <Button
                color='secondary'
                onClick={onLogout}
                disabled={isLogoutInProgress}
              >
                {t('logoutButton')}
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </Grid>
    </AppBar>
  );
}

export default NavBar;